exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2uZ2Dzi20pECWklNIEqSr8 {\n  margin: 0;\n  line-height: 1;\n}\n", ""]);
// Exports
exports.locals = {
	"header": "_2uZ2Dzi20pECWklNIEqSr8"
};